<template lang="pug">
  v-menu(
    v-model="menuLanguage"
    close-on-click
    close-on-content-click
    offset-y
    bottom
    left)
    template(v-slot:activator="{ on }")
      v-btn(color="primary" v-on="on")
        span.d-flex(v-for="item, i in images"  :key="'selected'+i")
          img.headernavbar__flag(v-if="language == item.key"  :src="item.url"  :alt="item.alt")
    v-list
      v-list-item(v-for="item, i in images"  :key="'list'+i")
        v-list-item-title(@click="selectedLanguage(item.key)")
          img.headernavbar__flag(:src="item.url"  :alt="item.alt")
</template>

<script>
  export default {
    name: "ButtonSelectLenaguage",
    props: {
      translations: {
        type: Object,
        default: function(){
          return {}
        }
      },
    },
    data: () => ({
      menuLanguage: false,
      images: {
        es: {
          key: 'es',
          alt: 'Español',
          url: require('@/assets/es.svg'),
        }
      }
    }),
    computed: {
      language(){
        return this.$i18n.locale;
      }
    },
    created(){
      this.setLanguages();
    },
    methods: {
      setLanguages() {
        const vm = this;
        Object.keys(this.translations).forEach((item)=>{
          vm.images[item] = {
            key: item,
            alt: vm.translations[item].alt,
            url: require('@/assets/'+vm.translations[item].url)
          }
        })
      },
      selectedLanguage(lang) {
        this.$i18n.locale = lang;
      }
    }
  }
</script>

<style lang="sass">
</style>